import {DEFAULT_LINE_PLOT_SETTINGS} from '../../WorkspaceDrawer/Settings/runLinePlots/linePlotDefaults';
import {LinePlotDisplayFnArgs} from '../types';
import {LinePlotTemplateSettings} from '../workspaceTemplatesQueries';

export const getMaxRunsDisplayRow = ({
  currTemplateLinePlotSettings,
  currWorkspaceLinePlotSettings,
}: LinePlotDisplayFnArgs) => {
  const currTemplateMaxRuns = currTemplateLinePlotSettings?.maxRuns;

  const newTemplateMaxRuns = currWorkspaceLinePlotSettings?.maxRuns;
  const newMaxRunsValue =
    newTemplateMaxRuns ?? DEFAULT_LINE_PLOT_SETTINGS.limit;

  return {
    groupTitle: 'Max number of runs',
    label: 'Max runs',
    field: 'maxRuns' as keyof LinePlotTemplateSettings,
    // preserve the value that's used in db
    currValue: currTemplateMaxRuns,
    currDisplayValue:
      currTemplateMaxRuns == null ? undefined : currTemplateMaxRuns.toString(),
    newValue: newMaxRunsValue,
    newDisplayValue: newMaxRunsValue.toString(),
  };
};
